/**
 * Scrolls an element into view including nested scrolls
 *
 * @param {Element} targetElement
 * @param {number} [outerOffset] Outer offset, relative to screen viewport
 * @param {number} [innerOffset] Inner offset, relative to inner containers
 */
function scrollToElement(targetElement, outerOffset = 100, innerOffset = 40) {
    // We need to scroll all parent containers to make sure target element is visible
    traverseParents(targetElement, currentElement => {
        /** @var {HTMLElement} currentElement */
        if (currentElement.parentElement) {
            if (currentElement === document.body) {
                // Skip body check
                return;
            }

            // Check if parent is scrollable
            const parentScrollHeight = currentElement.parentElement.scrollHeight;
            const parentClientHeight = currentElement.parentElement.clientHeight;

            if (parentClientHeight < parentScrollHeight) {
                // Parent is scrollable set scroll to target position
                currentElement.parentElement.scrollTop =
                    yRelativeToParent(currentElement.parentElement, targetElement) - innerOffset;
            }
        } else {
            // Reached the end of the tree, scroll viewport to element
            const y = targetElement.getBoundingClientRect().top + window.scrollY;

            window.scroll({
                top: y - outerOffset,
                behavior: 'smooth'
            });
        }
    })
}

/**
 * Returns the y value of a child relative to a parent by
 * comparing bounding boxes and scrolled distances
 *
 * @param {Element} parent
 * @param {Element} child
 */
function yRelativeToParent(parent, child) {
    let y = 0;

    const parentYPosition = parent.getBoundingClientRect().y;
    const parentYScroll = parent.scrollTop;
    const childYPosition = child.getBoundingClientRect().y;

    y += childYPosition - parentYPosition + parentYScroll;

    return y;
}

/**
 * Iterates through the parents of the provided element, including itself
 *
 * @param {Element} element
 * @param {(element: Element) => void} handleElement
 */
function traverseParents(element, handleElement) {
    handleElement(element);
    if (element.parentElement) {
        traverseParents(element.parentElement, handleElement);
    }
}

export {scrollToElement}
